import { useState } from 'react'
import {
  UploadFileProps,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@wellesley/ui'
import { UploadItem } from '@wellesley/uploads'
import { LocalFilesTab } from './LocalFilesTab'
import { ExternalURLTab } from './ExternalURLTab'
import { AttachmentsTab } from './AttachmentsTab'

type SelectionViewProps = {
  attachments: UploadItem[]
  onLocalFileUpload: (files: UploadFileProps[]) => void
  onExternalUrlInsert: (url: string) => void
  onAttachmentsInsert: (
    selectedIds: string[],
    allAttachments: UploadItem[],
  ) => void
}

export const SelectionView = ({
  attachments,
  onLocalFileUpload,
  onExternalUrlInsert,
  onAttachmentsInsert,
}: SelectionViewProps) => {
  const [selectedTab, setSelectedTab] = useState<string>('local')

  return (
    <Tabs value={selectedTab} onValueChange={setSelectedTab}>
      <TabsList className="px-s pt-s" useDefaults={true}>
        <TabsTrigger value="local" isFullWidthTab={true}>
          <button
            type="button"
            className="flex h-full w-full items-center justify-center"
          >
            Local Files
          </button>
        </TabsTrigger>
        <TabsTrigger value="url" isFullWidthTab={true}>
          <button
            type="button"
            className="flex h-full w-full items-center justify-center"
          >
            External URL
          </button>
        </TabsTrigger>
        <TabsTrigger value="attachments" isFullWidthTab={true}>
          <button
            type="button"
            className="flex h-full w-full items-center justify-center"
          >
            Attachments
          </button>
        </TabsTrigger>
      </TabsList>

      <div className="p-s">
        <TabsContent value="local">
          <LocalFilesTab onUpload={onLocalFileUpload} />
        </TabsContent>

        <TabsContent value="url">
          <ExternalURLTab
            onInsert={onExternalUrlInsert}
            isActive={selectedTab === 'url'}
          />
        </TabsContent>

        <TabsContent value="attachments">
          <AttachmentsTab
            attachments={attachments}
            onInsert={onAttachmentsInsert}
          />
        </TabsContent>
      </div>
    </Tabs>
  )
}
